import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '@app/_services';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }

  // Endpoints that should NOT trigger auto-logout on 401/403
  private publicEndpoints = [
    '/users/authenticate',
    '/users/verify-2fa',
    '/users/2fa/complete-setup',
    '/users/verify-2fa/resend',
    '/users/register',
    '/users',
    '/password_reset',
    '/forgot-password',
    '/activate-account'
  ];

  private isPublicEndpoint(url: string): boolean {
    return this.publicEndpoints.some(endpoint => url.includes(endpoint));
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {

        const isPublic = this.isPublicEndpoint(request.url);

        // Only auto-logout for 401/403 on PROTECTED endpoints
        if ((err.status === 401 || err.status === 403) && !isPublic) {
          this.authenticationService.logout();
          window.location.reload();
        }

        // For public endpoints, pass the FULL error object through
        // Use throwError(err) directly - not the factory function
        return throwError(err);
      }))
  }
}
//
// import { Injectable } from '@angular/core';
// import { HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { catchError } from 'rxjs/operators';
//
// import { AuthenticationService } from '@app/_services';
//
// @Injectable({
//     providedIn: 'root'
// })
// export class ErrorInterceptor implements HttpInterceptor {
//     constructor(private authenticationService: AuthenticationService) { }
//
//     intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//
//         return next.handle(request).pipe(
//             catchError(err => {
//
//                 if (err.status === 401 || err.status === 403) {
//                     this.authenticationService.logout();
//                     // location.reload(true);
//                     window.location.reload();
//                 }
//
//                 const error = err.error.message || err.statusText;
//                 return throwError(error);
//             }))
//     }
// }
